import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class BookOnlineFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: "Book Online",
      name: "bookOnline",
      value,
    });
  }
}

export default BookOnlineFilter;
export { BookOnlineFilter };
